import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import FmsDashboardPage from '../app/fms/pages/FmsDashboardPage'
import DocumentListPage from '../app/fms/pages/DocumentListPage'
import BarcodeListPage from '../app/fms/pages/BarcodeListPage'
import DocumentDetailsPage from '../app/fms/pages/DocumentDetailsPage'
import DocumentSearchPage from '../app/fms/pages/DocumentSearchPage'
import DocumentDashboardPage from '../app/fms/pages/DocumentDashboardPage'

// Counter




function FmsRoutes() {

    const {authUser} = useAuth()

    return (
        <Routes>
            {/* FMS Routes */}
            <Route path="/fms/dashboard" element={<FmsDashboardPage /> }></Route>
            <Route path="/fms/barcode-list" element={<BarcodeListPage /> }></Route>
            <Route path="/fms/document-dashboard" element={<DocumentDashboardPage /> }></Route>
            <Route path="/fms/document-list" element={<DocumentListPage/> }></Route>
            <Route path="/fms/search" element={<DocumentSearchPage /> }></Route>
            <Route path="/fms/document/:documentId" element={<DocumentDetailsPage /> }></Route>
        </Routes>
        
    )
}

export default FmsRoutes